import { render, staticRenderFns } from "./AdviseMessage.vue?vue&type=template&id=56941ef4&scoped=true&"
import script from "./AdviseMessage.vue?vue&type=script&lang=js&"
export * from "./AdviseMessage.vue?vue&type=script&lang=js&"
import style0 from "./AdviseMessage.vue?vue&type=style&index=0&id=56941ef4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56941ef4",
  null
  
)

export default component.exports